<script lang="ts">
  import ShowMoreArrow from '../components/icons/ShowMoreArrow.svelte';
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let isEditable = false;
  export let itemsLength: number;
  export let currentItems: number;

  let isShowLess;

  const showMore = () => {
    dispatch('showMore');
  };

  const hideItems = () => {
    dispatch('showLess');
  };

  $: isShowLess =
    itemsLength === currentItems && currentItems > 3 && !isEditable;
</script>

{#if currentItems < itemsLength}
  <button class="more" on:click={showMore}>
    <ShowMoreArrow />
    <span>show more</span>
    <ShowMoreArrow />
  </button>
{:else if isShowLess}
  <button class="more" on:click={hideItems}>
    <ShowMoreArrow isReverse />
    <span>show less</span>
    <ShowMoreArrow isReverse />
  </button>
{/if}

<style>
  button {
    display: block;
    margin: 0 auto;
  }
  span {
    margin-right: 23px;
    margin-left: 23px;
  }
  .more {
    max-width: 200px;
    width: 100%;
    height: 48px;
    background: transparent;
    cursor: pointer;
    border: 1px solid var(--vlt-lp-primary);
    border-radius: 4px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: var(--vlt-lp-primary);
    text-transform: capitalize;
    margin-top: 30px;
  }
</style>
